var TallLoadingIndicator = function(jElList) {
    var m_jElList = (typeof jElList == "string") ? $(jElList) : jElList, m_jLoadingList = $(), m_jWindow = $(window);

    /**
     * Fire it up
     */
    function initialize() {
        m_jElList
                .each(function(i, el) {
                    var jEl = $(el), jLoading = $('<div class="whiteWashedBackground" />'), jAnim = $('<div class="tallLoadingAnimation" />'), strPosition = jEl
                            .css('position');

                    if (strPosition != 'absolute') {
                        jEl.css({
                            position : 'relative'
                        });
                    }

                    jLoading.append(jAnim);
                    jEl.append(jLoading);

                    m_jLoadingList = m_jLoadingList.add(jLoading);
                });

        m_jLoadingList.css({
            opacity : 0
        });
        m_jLoadingList.animate({
            opacity : 0.8
        });
    }

    initialize();

    this.destroy = function() {
        m_jLoadingList.animate({
            opacity : 0
        }, function() {
            m_jLoadingList.remove();
        });
    };
};
